import { createFileRoute } from '@tanstack/react-router';

import { ProtectedRoute } from '@/components';
import HeadingClientsDashboard from '@/pages/HeadingClientsDashboard';

export const Route = createFileRoute('/config/rubriques-clients')({
  component: () => (
    <ProtectedRoute>
      <HeadingClientsDashboard />
    </ProtectedRoute>
  ),
});
